// extracted by mini-css-extract-plugin
export default {"container":"SwapWidgetSkeleton_container__JKy1L"};